import { EQUIPMENT_GROUP_IDS, type EquipmentGroupId } from './equipment-groups.constants';

const GROUP_IDS = new Set<string>(Object.values(EQUIPMENT_GROUP_IDS));

/** True when the route `viewId` is one of the client-side groups, not a BFF view. */
export function isEquipmentGroupId(viewId: string | undefined): viewId is EquipmentGroupId {
  return viewId !== undefined && GROUP_IDS.has(viewId);
}
